export default __webpack_public_path__ + "static/media/fee.98c9e56a.svg";